module.exports = __webpack_public_path__ + "static/img/83d6921c7b334136e559155d479691d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/six_icon2.png
// module id = DXX5
// module chunks = 1